import { useState, useEffect, useCallback } from 'react';
import ImageComponent from 'next/image';
import { X } from 'lucide-react';
import { FullscreenModalProps } from './types';

export const FullscreenModal = ({
  imageUrl,
  prompt,
  onClose,
}: FullscreenModalProps) => {
  const [dimensions, setDimensions] = useState({ width: 1000, height: 1000 });

  useEffect(() => {
    const img = new Image();
    img.src = imageUrl;
    img.onload = () => {
      setDimensions({
        width: img.naturalWidth,
        height: img.naturalHeight,
      });
    };
  }, [imageUrl]);

  const handleBackdropClick = useCallback(
    (e: React.MouseEvent) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    },
    [onClose]
  );

  return (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/80"
      onClick={handleBackdropClick}
    >
      <button
        onClick={onClose}
        className="absolute right-4 top-4 rounded-full bg-white/10 p-2 text-white hover:bg-white/20"
      >
        <X className="h-6 w-6" />
      </button>
      <ImageComponent
        src={imageUrl}
        alt="Fullscreen view"
        width={dimensions.width}
        height={dimensions.height}
        className="max-h-[80vh] max-w-[90vw] cursor-zoom-in object-contain transition-transform duration-300"
        priority
        onClick={(e) => {
          const img = e.currentTarget;
          if (img.classList.contains('zoomed')) {
            img.classList.remove('zoomed');
            img.style.transform = 'scale(1)';
          } else {
            img.classList.add('zoomed');
            const rect = img.getBoundingClientRect();
            const x = (e.clientX - rect.left) / rect.width;
            const y = (e.clientY - rect.top) / rect.height;
            img.style.transformOrigin = `${x * 100}% ${y * 100}%`;
            img.style.transform = 'scale(2.5)';
          }
        }}
      />
      <div className="mt-4 max-w-[90vw] px-4 text-center">
        <p className="text-sm text-white/80">{prompt}</p>
      </div>
    </div>
  );
};
